export default {"src":"/_next/static/media/linkedin-logo.09ebf21e.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};